module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_05-a4f5ca0fadd33862f5481fc60660fbd7.svg";